import React from 'react';
import ModalSeats from '../../ModalSeats';
import BackButton from '../BackButton';
import Map from './Map';
export default function Seats({
    availability,
    currentInventory,
    previousZone,
    form,
    inventories,
    categories = [],
    currency,
    onBackToRoot,
    sync,
    rates,
    onAddAttendee = () => {},
    onSetRates = () => {}
}) {
    const [seatModalMode, setSeatModalMode] = React.useState(false);
    const [hoveredSeat, setHoveredSeat] = React.useState(null);
    const [selectedSeats, setSelectedSeats] = React.useState([]);

    const handleBack = React.useCallback(() => {
        onBackToRoot();
    }, [onBackToRoot]);

    const handleHover = React.useCallback(seat => {
        if (selectedSeats?.length) {
            return;
        }
        setHoveredSeat(seat);
    }, []);

    const handleSelect = React.useCallback(
        s => {
            if (s.booking_state === 'AVAILABLE') {
                setSeatModalMode(true);
                setSelectedSeats([s]);
            }
        },
        [setSeatModalMode, setSelectedSeats]
    );

    const handleGroupSelect = React.useCallback(
        s => {
            const seats = s.filter(function(seat) {
                return seat.booking_state === 'AVAILABLE';
            });
            setSeatModalMode(true);
            setSelectedSeats(seats);
        },
        [setSelectedSeats, setSeatModalMode]
    );

    const handleUnselect = React.useCallback(s => {
        setSelectedSeats([]);
        setSeatModalMode(false);
    }, []);

    return (
        <div>
            <BackButton name={availability.name} onBack={handleBack} />
            {seatModalMode ? (
                <ModalSeats
                    seats={selectedSeats}
                    availability={availability}
                    previousZone={previousZone}
                    categories={categories}
                    onClose={handleUnselect}
                    onAddAttendee={onAddAttendee}
                    setSeatModalMode={setSeatModalMode}
                    onSetRates={onSetRates}
                    inventories={inventories}
                    currency={currency}
                    sync={sync}
                    rates={rates}
                    currentInventory={currentInventory}
                />
            ) : null}
            <Map
                availability={availability}
                selectedSeats={selectedSeats}
                handleHover={handleHover}
                handleGroupSelect={handleGroupSelect}
                handleSelect={handleSelect}
                hoveredSeat={hoveredSeat}
                categories={categories}
                currentInventory={currentInventory}
                form={form}
            />
        </div>
    );
}
